import { Navigate } from "react-router";
import { isValidUser } from "../authConfig";

/**
 * ProtectedRoute component that redirects to login if user is not authenticated.
 * Wraps protected content and checks for user in localStorage.
 */
const ProtectedRoute = ({ children }) => {
  const savedUser = JSON.parse(localStorage.getItem("user"));
  const isAuthenticated = isValidUser(savedUser);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
